import { FC } from 'react';
import Button from 'components/commercetools-ui/atoms/button';
import Message from 'components/commercetools-ui/atoms/message';
import { useFormat } from 'helpers/hooks/useFormat';
import { useCart } from 'frontastic';

interface Props {
  paymentStatus: string;
}

const BackToCheckout: FC<Props> = ({ paymentStatus }) => {
  const { formatMessage: formatCheckoutMessage } = useFormat({ name: 'checkout' });
  const handleGoToCheckout = () => {
    window.location.assign('/checkout/');
  };

  const { data: cartData } = useCart();
  const giftCards = cartData?.payments?.filter((item) => {
    return item.paymentProvider === 'giftcard';
  });

  const refusedMessage = `Unfortunately, we were unable to take payment for this order and no payment has been taken. ${
    giftCards && giftCards?.length >= 2
      ? 'Please review your chosen payment methods.'
      : 'Please try again using a different payment method.'
  }`;

  const handleHome = () => {
    window.location.assign('/');
  };

  const message = () => {
    if (paymentStatus === 'refused') {
      return (
        <Message
          severity={'error'}
          message={formatCheckoutMessage({
            id: `payment.refused`,
            defaultMessage: refusedMessage,
          })}
        ></Message>
      );
    } else if (paymentStatus === 'cancelled') {
      return (
        <Message
          severity={'error'}
          message={formatCheckoutMessage({
            id: `payment.cancelled`,
            defaultMessage:
              'Your payment has been cancelled. If this was a mistake or you wish to attempt the payment again, please return to the checkout page.',
          })}
        ></Message>
      );
    } else if (paymentStatus === 'pending') {
      return (
        <Message
          severity={'info'}
          message={formatCheckoutMessage({
            id: `payment.pending`,
            defaultMessage: 'Order has been successfully received.  Please complete your payment in iDEAL to continue.',
          })}
        ></Message>
      );
    }
  };

  return (
    <div className="m-auto my-40 w-fit">
      {message()}
      {paymentStatus !== 'pending' && (
        <div className="text-center">
          <Button variant="secondary" size="m" onClick={handleGoToCheckout} className="w-full md:w-auto">
            GO TO CHECKOUT
          </Button>
        </div>
      )}
      {paymentStatus === 'pending' && (
        <div className="text-center">
          <Button variant="secondary" size="m" onClick={handleHome} className="w-full md:w-auto">
            CONTINUE SHOPPING
          </Button>
        </div>
      )}
    </div>
  );
};

export default BackToCheckout;
